// SOPHIA-23138
// ADA: show blue box focus when user use TAB keys
import $ from 'jquery'

$(document).on('keyup', function(e) {
  if (e.keyCode == $.ui.keyCode.TAB && !e.shiftKey || $.ui.keyCode.TAB && e.shiftKey) {
    e.preventDefault();
    $('body').addClass('focus-by-tab');
  }
});

$(document).on('click', function() {
  $('body').removeClass('focus-by-tab');
});

$(document).on('keyup', '.checkbox-container', e => {
  if (e.keyCode == $.ui.keyCode.SPACE) {
    e.preventDefault();
    $(e.target).closest('li').find('input[type="checkbox"]').trigger('click');
  }
});
